module.exports = "/fonts/opensansbolditalic.woff";